<template>
    <div>
        <div>评论 <br>
            <a-rate :tooltips="scoreDesc" v-model="commentInfo.score" style="margin: 10px 0"/>
            <span class="ant-rate-text">{{scoreDesc[commentInfo.score - 1]}}</span>
        </div>
        <div>
            <a-textarea
                    placeholder="请发表您对课程的评价"
                    :autosize="{ minRows: 6, maxRows: 6 }"
                    v-model="commentInfo.commentContent"
            />

            <a-button @click="publishComment" type="primary" style="float: right;margin: 20px 0 0 0">发表评论</a-button>
            <div style="clear: both"></div>
        </div>
        <hr style="margin:20px 0px;height:1px;border:0px;background-color:#E8E8E8;color:#E8E8E8;"/>

        <div class="commentDetail" v-for="(item,index) in commentList" :key="item.commentId">
            <div class="comment-detail-list">
                <div style="width: 50%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap; ">
                    <a-avatar icon="user" :src="item.user.avatarUrl||item.user.wechatAvatar || null"
                              style="vertical-align:middle"/>
                    <span style="vertical-align:middle;margin: 0 10px;width: 50%;overflow: hidden">
                        {{item.user.nickname}}
                    </span>
                </div>
                <div>
                    <a-rate :defaultValue="item.score" disabled style="float: right"/>
                </div>

            </div>
            <p style="padding: 10px 0 10px 40px">
                {{item.commentContent}}
            </p>
            <p class="commentDetail-time">
                {{item.createdTime | formatDate("YYYY-MM-DD HH:mm")}}
                <span style="margin-left: 6px" class="commentDetail-reply-text" @click="showReply(item,index)"
                      v-if="item.userId != userInfo.userId"> 回复</span>
                <span v-if="isLogin && userInfo.userId === item.userId" class="commentDetail-delete"
                      @click="removeComment(item.commentId)"><a-icon type="delete"/></span>
            </p>
            <!--            <p style="margin: 10px 0" v-if="item.iSshowReplyTextarea">-->
            <!--                <a-avatar icon="user" :src="item.user.avatarUrl||item.user.wechatAvatar || null"-->
            <!--                          style="vertical-align:top"/>-->
            <!--                <a-textarea v-model="ReplyText" style="width: 900px;margin-left: 10px" placeholder="请输入回复内容"-->
            <!--                            :autosize="{ minRows: 2, maxRows: 2 }"/>-->
            <!--                <a-button type="primary" style="width: 100px;height: 52px;padding: 0" @click="reply(item.commentId)">-->
            <!--                    发表回复-->
            <!--                </a-button>-->
            <!--            </p>-->

            <div class="comment-answer" v-if="item.subCommentList.length>0">

                <dt v-for="sonItem in item.subCommentList" :key="sonItem.commentId">
                    <a-avatar icon="user" :src="sonItem.user.avatarUrl||item.user.wechatAvatar || null"
                              style="vertical-align:middle"/>
                    <span style="vertical-align:middle;margin: 0 10px;width: 50%;overflow: hidden">
                       <span style="color: #1890ff">{{sonItem.user.nickname}}</span> <span>回复</span>
                        <span style="color: #1890ff">{{sonItem.parentUserName}}：</span> {{sonItem.commentContent}}
                    </span>
                    <br>

                    <div style="color: #999999;font-weight: normal;text-align: right">
                        {{sonItem.createdTime | formatDate("YYYY-MM-DD HH:mm")}}
                        <span v-if="isLogin && sonItem.userId != userInfo.userId" class="commentDetail-reply-text"
                              @click="showReply(sonItem,index)"> 回复</span>
                        <span v-if="isLogin && userInfo.userId === sonItem.userId" class="commentDetail-delete"
                              @click="removeComment(sonItem.commentId)"><a-icon type="delete"/></span>
                    </div>

                </dt>
            </div>
            <p style="margin: 20px 0 0 40px" v-if="item.iSshowReplyTextarea">
                <!--                <a-avatar icon="user" :src="item.user.avatarUrl||item.user.wechatAvatar || null"-->
                <!--                          style="vertical-align:top"/>-->
                <a-textarea v-model="ReplyText" :placeholder="placeholder"
                            :autosize="{ minRows: 2, maxRows: 2 }"/>
                <a-button type="primary" style="width: 88px;float: right;margin: 10px 0" @click="reply()">发表回复
                </a-button>
            </p>
            <!--                    分割线 -->
            <a-divider/>
        </div>
        <!--翻页-->
        <a-pagination @change="changePage" :total="total" :pageSize="pageSize" style="text-align: center"/>
    </div>
</template>

<script>
    import common from "../../../mixin/common";
    import {addComment, removeComment, commentList, liveOnlineCommentSectionList} from "@api/courese-detail";
    import {addreply} from "@api/courese-detail";
    import {showError, showSuccessMsg, showWaringMsg} from "@utils/msg";
    import {createNamespacedHelpers} from "vuex";

    const {mapState} = createNamespacedHelpers('login');

    export default {
        mixins: [common],
        data() {
            return {
                scoreDesc: ['差', '一般', '中等', '好', '非常好'],
                total: 0,
                pageSize: 10,
                commentInfo: {
                    commentContent: '',
                    score: 5
                },
                commentList: [],
                value: "",
                //显示回复文本域
                iSshowReplyTextarea: false,
                //    回复文字内容
                ReplyText: "",
                replyComment: null,
                //    请输入回复内容
                placeholder: "请输入回复内容",
                //    评论id
                commentId: -1,

            }
        },
        props: {
            courseId: [String, Number],
            sectionId: [String, Number],
            isCoursePlay: Boolean
        },
        created() {
            this.changePage(1);
            // console.log(this.userInfo)
        },
        computed: {
            ...mapState({
                isLogin: 'isLogin',
                userInfo: "userInfo"
            })
        },
        methods: {
            //    发表评论
            publishComment() {
                if (this.isLoginClick()) {
                    if (this.commentInfo.commentContent == "" || this.commentInfo.score == 0) {
                        showWaringMsg("请确认评分和评论均不为空，烦请认真评论，感谢你的评论，每一个好评都是我们前进路上的动力！");
                    } else {
                        addComment(this.sectionId, this.commentInfo.commentContent, this.commentInfo.score, this.courseId).then((res) => {
                            if (res.code == 0) {
                                showSuccessMsg("评论成功，感谢你的评论，每一个好评都是我们前进路上的动力！");
                                this.commentInfo.commentContent = ""
                                this.commentInfo.score = 5;
                                //  重新加载一下列表
                                this.changePage(1);
                            } else {
                                showError(res.msg);
                            }
                        })
                    }
                }
            },
            //删除评论
            removeComment(commentId) {
                if (this.isLoginClick()) {
                    this.$modal.confirm({
                        title: '确认',
                        content: '您确定要删除评论吗？',
                        onOk: () => {
                            removeComment(commentId).then((res) => {
                                if (res.code == 0) {
                                    showSuccessMsg(res.msg)
                                    //  重新加载一下列表
                                    this.changePage(1);
                                } else {
                                    showError(res.msg)
                                }
                            })
                        },
                        okText: '确定',
                        cancelText: '取消'
                    })
                }

            },

            //    课程评论翻页
            changePage(current) {
                if (this.isCoursePlay) {
                    liveOnlineCommentSectionList(this.sectionId, current, this.pageSize).then((res) => {
                        // console.log(res)
                        this.total = res.total;
                        this.commentList = res.rows
                        for (let i = 0; i < this.commentList.length; i++) {
                            this.commentList[i].showReplyTextarea = false
                        }

                    })
                } else {
                    commentList(this.courseId, current, this.pageSize).then((res) => {
                        // console.log(res)
                        this.total = res.total;
                        this.commentList = res.rows
                        for (let i = 0; i < this.commentList.length; i++) {
                            this.commentList[i].showReplyTextarea = false
                        }
                    })
                }

            },
            showReply(comment, selectedIndex) {
                if (this.isLoginClick()) {
                    // console.log(comment)
                    this.commentId = comment.commentId
                    this.placeholder = "回复" + comment.user.nickname + "："
                    this.commentList.forEach((item, index) => {
                        if (index === selectedIndex) {
                            item.iSshowReplyTextarea = true;
                        } else {
                            item.iSshowReplyTextarea = false;
                        }
                    });
                    // 回复的评论内容
                    this.replyComment = comment;
                    this.commentList = this.commentList.concat();
                }
            },
            reply() {
                if (this.ReplyText && this.ReplyText.trim()) {
                    // 回复评论 commentId,courseId,sectionId,commentContent,score
                    addreply(this.commentId, this.courseId, this.sectionId, this.ReplyText).then((res) => {
                        // console.log(res)
                        if (res.code == 0) {
                            this.ReplyText = ""
                            showSuccessMsg("回复成功！");
                            //  重新加载一下列表
                            this.changePage(1);
                        } else {
                            showError(res.msg);
                        }
                    })

                } else {
                    showWaringMsg("请确认评论不为空！")
                    this.ReplyText = ""
                }

            }

        },
        watch: {
            sectionId() {
                this.changePage(1)
            }
        }
    }

</script>

<style lang="less" scoped>
    .commentDetail-time {
        padding: 0 10px 0 0;
        color: #999999;
        text-align: right;
    }

    .commentDetail-delete, .commentDetail-reply-text:hover {
        color: #00CF8C;
        cursor: pointer;
    }

    .commentDetail-reply-text {
        /*color: #999999;*/
        color: #777777;
        margin-left: 6px;
    }

    .commentDetail-delete {
        /*float: right;*/
        color: #FF4F23;
        margin-left: 16px;
        font-size: 16px;

    }

    .comment-detail-list {
        display: flex;
        justify-content: space-between;
        -webkit-box-pack: justify;
        align-items: center;
    }

    .comment-answer {
        margin: 20px 0px 0 40px;
        padding: 10px;
        border: 1px solid #D9D9D9;
        background: #FAFAFA;

        dt {
            margin-top: 8px;
            padding-bottom: 10px;
            border-bottom: 1px solid #e8e8e8;
        }

        dt:nth-last-child(1) {
            border-bottom: none;
        }
    }

</style>
